module.exports = __webpack_public_path__ + "10adffe69bc6b4dc03f0aa6812037b9e.svg";